import React, { useEffect } from "react";

// PDF served from public/documents/ folder (not bundled by webpack)
const resumeFile = process.env.PUBLIC_URL + "/images/documents/CarlosRamirezResume.pdf";

const Resume = () => {
  useEffect(() => {
    // Set noindex meta tag to hide from search engines
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    // Update page title
    const originalTitle = document.title;
    document.title = "Carlos A. Ramirez — Resume";

    return () => {
      document.head.removeChild(meta);
      document.title = originalTitle;
    };
  }, []);

  return (
    <div style={styles.page}>
      {/* Subtle back arrow */}
      <a href="/" style={styles.backLink} title="Back to portfolio">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="19" y1="12" x2="5" y2="12" />
          <polyline points="12 19 5 12 12 5" />
        </svg>
        <span style={styles.backText}>Back</span>
      </a>

      {/* Header */}
      <div style={styles.header}>
        <h1 style={styles.name}>Carlos A. Ramirez</h1>
        <p style={styles.subtitle}>Full Stack Engineer</p>
      </div>

      {/* PDF Viewer Container */}
      <div style={styles.viewerContainer}>
        <iframe
          src={`${resumeFile}#toolbar=1&navpanes=0&view=FitH`}
          style={styles.iframe}
          title="Resume - Carlos A. Ramirez"
        />
      </div>

      {/* Download button */}
      <div style={styles.footer}>
        <a href={resumeFile} download="CarlosRamirezResume.pdf" style={styles.downloadBtn}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ marginRight: "8px" }}
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="7 10 12 15 17 10" />
            <line x1="12" y1="15" x2="12" y2="3" />
          </svg>
          Download PDF
        </a>
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700&family=Playfair+Display:wght@400;600&display=swap');

        body {
          margin: 0;
          padding: 0;
        }

        /* Back link hover */
        a[href="/"] {
          transition: opacity 0.2s ease, transform 0.2s ease;
        }
        a[href="/"]:hover {
          opacity: 1 !important;
          transform: translateX(-3px);
        }

        /* Download button hover */
        a[download]:hover {
          background-color: #1a1a1a !important;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.15);
        }
      `}</style>
    </div>
  );
};

const styles = {
  page: {
    minHeight: "100vh",
    backgroundColor: "#f8f7f4",
    fontFamily: "'DM Sans', sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0",
  },
  backLink: {
    position: "fixed",
    top: "24px",
    left: "24px",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "#333",
    textDecoration: "none",
    opacity: 0.5,
    zIndex: 10,
    fontSize: "14px",
    fontFamily: "'DM Sans', sans-serif",
  },
  backText: {
    fontWeight: 500,
    letterSpacing: "0.02em",
  },
  header: {
    textAlign: "center",
    paddingTop: "48px",
    paddingBottom: "24px",
  },
  name: {
    fontFamily: "'Playfair Display', serif",
    fontSize: "28px",
    fontWeight: 600,
    color: "#1a1a1a",
    margin: "0 0 6px 0",
    letterSpacing: "-0.01em",
  },
  subtitle: {
    fontSize: "14px",
    fontWeight: 400,
    color: "#888",
    margin: 0,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
  },
  viewerContainer: {
    width: "100%",
    maxWidth: "850px",
    flex: 1,
    padding: "0 24px",
    boxSizing: "border-box",
  },
  iframe: {
    width: "100%",
    height: "calc(100vh - 200px)",
    minHeight: "600px",
    border: "1px solid rgba(0,0,0,0.08)",
    borderRadius: "8px",
    boxShadow: "0 2px 20px rgba(0,0,0,0.06)",
    backgroundColor: "#fff",
  },
  footer: {
    padding: "24px 0 40px",
    textAlign: "center",
  },
  downloadBtn: {
    display: "inline-flex",
    alignItems: "center",
    padding: "10px 24px",
    backgroundColor: "#2d2d2d",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "6px",
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: "0.02em",
    transition: "all 0.2s ease",
  },
};

export default Resume;